import { useMemo, useEffect } from 'react';
import './liveFilter.sass';

/**
 * Componente de filtrado por eventos en vivo
 * Muestra un checkbox con contador de eventos en vivo
 * Solo se habilita si hay eventos en vivo disponibles
 * Por defecto muestra juegos NO en vivo
 * Al activar el filtro muestra SOLO juegos en vivo
 * 
 * @param {Object} props
 * @param {Array} props.tabsData - Datos de todas las tabs
 * @param {number} props.currentTab - Tab actualmente activa
 * @param {boolean} props.isLiveOnly - Si mostrar solo eventos en vivo (true = en vivo, false = no en vivo)
 * @param {Function} props.onLiveChange - Callback cuando cambia el filtro
 */
export default function LiveFilter({ tabsData, currentTab, isLiveOnly, onLiveChange, isViewingToday }) {
  // Contar eventos en vivo en toda la respuesta
  const liveCount = useMemo(() => {
    // Solo calcular si estamos viendo HOY
    if (!isViewingToday) {
      return 0;
    }

    const currentTabData = tabsData[currentTab - 1];
    
    if (!currentTabData?.data?.sports) {
      return 0;
    }

    let count = 0;
    currentTabData.data.sports.forEach(sport => {
      if (sport.leagues && Array.isArray(sport.leagues)) {
        sport.leagues.forEach(league => {
          if (league.games && Array.isArray(league.games)) {
            league.games.forEach(game => {
              if (game.class === 'clarosports-in-progress-game') {
                count++;
              }
            });
          }
        });
      }
    });

    return count;
  }, [isViewingToday, currentTab, tabsData]);

  // Si no hay eventos en vivo, desactivar el filtro
  useEffect(() => {
    if (liveCount === 0 && isLiveOnly) {
      onLiveChange(false);
    }
  }, [liveCount, isLiveOnly, onLiveChange]);

  return (
    <div className="live-filter-container">
      <button
        className={`live-filter-button ${isLiveOnly && liveCount > 0 ? 'active' : liveCount === 0  ? 'liveNone' : 'inactive'}`}
        onClick={() => onLiveChange(!isLiveOnly)}
        disabled={liveCount === 0}
        aria-label="Filtrar solo eventos en vivo"
        aria-pressed={isLiveOnly && liveCount > 0}
      >
        <span className="live-filter-text">DEPORTES EN VIVO</span>
        <span className="live-filter-counter">{liveCount}</span>
      </button>
    </div>
  );
}
